(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3400],{

/***/ 29404:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snapgene-viewer",
      function () {
        return __webpack_require__(78775);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 76635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "section-try-for-free": __webpack_require__(33686),
    "snapgene-viewer": __webpack_require__(68241)
};


/***/ }),

/***/ 17209:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(76635),
    de: __webpack_require__(87739)
};


/***/ }),

/***/ 78775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ snapgene_viewer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Action.js
var Action = __webpack_require__(14593);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/ButtonLink.js
var ButtonLink = __webpack_require__(85765);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ViewerPageTemplate/index.js
var ViewerPageTemplate = __webpack_require__(23402);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/ResponsiveWrapper.js
var ResponsiveWrapper = __webpack_require__(41848);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/index.js + 1 modules
var Table = __webpack_require__(72379);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Tr.js
var Tr = __webpack_require__(455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Th.js
var Th = __webpack_require__(11794);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Thead.js
var Thead = __webpack_require__(40662);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Td.js
var Td = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Tbody.js
var Tbody = __webpack_require__(72483);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Title.js
var SimpleTemplate_Title = __webpack_require__(70504);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Form.js
var Form = __webpack_require__(3361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/index.js + 8 modules
var SmartForm = __webpack_require__(3816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/useTracking/index.js
var useTracking = __webpack_require__(59074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(39116);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js + 6 modules
var validation = __webpack_require__(89965);
;// CONCATENATED MODULE: ./src/ViewerForm/form.js

const initialState = {
    email: ""
};
const schema = {
    email: [
        [
            validation/* required */.C1,
            "errors.EMAIL_REQUIRED"
        ],
        [
            (0,validation/* isCorrectEmailLen */.jh)(64),
            "errors.EMAIL_INVALID_LENGTH"
        ],
        [
            validation/* isEmail */.Jh,
            "errors.WRONG_EMAIL"
        ]
    ]
};
const validateForm = (0,validation/* default */.ZP)(schema);

// EXTERNAL MODULE: ./src/utils/useResultStatus/index.js
var useResultStatus = __webpack_require__(4116);
// EXTERNAL MODULE: ./src/nprogress.js
var nprogress = __webpack_require__(24753);
// EXTERNAL MODULE: ./src/utils/exceptions/ActionFailException/index.js
var ActionFailException = __webpack_require__(28813);
;// CONCATENATED MODULE: ./src/utils/hubspot-form.js

const HUBSPOT_API_URL = "https://api.hsforms.com/submissions/v3/integration/submit";
const HUBSPOT_REQUIST_INIT = {
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    }
};
const hubspotBody = function(fields) {
    let submittedAt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    return JSON.stringify({
        submittedAt,
        fields
    });
};
const entriesToFields = (form)=>Object.entries(form).map((param)=>{
        let [name, value] = param;
        return {
            name,
            value
        };
    });
const errorsToMessage = (errors)=>{
    return errors.map((param)=>{
        let { errorType  } = param;
        return "errors.".concat(errorType);
    });
};
const getHubspotErrorMessage = (response)=>response.json().then((result)=>Array.isArray(result.errors) ? errorsToMessage(result.errors) : "".concat(response.status, " - ").concat(result.message));
/**
 * Factory creates a hubspot form
 *
 * @type {<F extends {} = Record<string, any>(
 *   portalId: string,
 *   formGuid: string,
 *   mapForm?: (form: F) => Array<{ name: string, value: any }>
 * ) => { submit(form: F): Promise<void> }}
 */ const HubspotForm = function(portalId, formGuid) {
    let mapForm = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : entriesToFields;
    const formUrl = "".concat(HUBSPOT_API_URL, "/").concat(portalId, "/").concat(formGuid);
    const submit = (form)=>fetch(formUrl, {
            ...HUBSPOT_REQUIST_INIT,
            body: hubspotBody(mapForm(form))
        }).then((response)=>response.ok ? null : getHubspotErrorMessage(response)).then((errorMessage)=>{
            if (errorMessage == null) return;
            throw new ActionFailException/* default */.Z(errorMessage, 400);
        });
    return {
        submit
    };
};
/* harmony default export */ var hubspot_form = (HubspotForm);

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/services/hubspot.js


const { HUBSPOT_PORTAL_ID , HUBSPOT_VIEWER_FORM_ID  } = config/* publicConfig */.mn;
const ViewerForm = hubspot_form(HUBSPOT_PORTAL_ID, HUBSPOT_VIEWER_FORM_ID);

// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/ViewerForm/action.js




const actionForm = (form)=>ViewerForm.submit(form).then((0,routes/* gotoPath */.pR)(routes/* default.snapgeneViewerDownload */.ZP.snapgeneViewerDownload));
/* harmony default export */ var ViewerForm_action = ((0,pipe/* default */.Z)(actionForm, (0,nprogress/* withLoading */.VT)("request-trial")));

;// CONCATENATED MODULE: ./src/ViewerForm/index.js












const ViewerForm_ViewerForm = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("snapgene-viewer");
    const [requestAction, isRequestProcessing] = (0,useTracking/* default */.ZP)(ViewerForm_action, useTracking/* CATCH */.av);
    const [action, { errors  }, resetResult] = (0,useResultStatus/* default */.Z)(requestAction);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isRequestProcessing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmartForm/* default */.ZP, {
                textRender: t,
                initialState: initialState,
                validateForm: validateForm,
                action,
                onTouched: resetResult,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "EMAIL",
                        name: "email",
                        type: "email",
                        disabled: isRequestProcessing,
                        error: errors.message,
                        fieldClassName: "mb-8",
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            spacing: {
                                mt: 4,
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                sx: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    disabled: isRequestProcessing,
                                    children: t("SUBMIT")
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var src_ViewerForm = (ViewerForm_ViewerForm);

// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./locales/snapgene-viewer-page/index.js
var snapgene_viewer_page = __webpack_require__(17209);
var snapgene_viewer_page_default = /*#__PURE__*/__webpack_require__.n(snapgene_viewer_page);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
;// CONCATENATED MODULE: ./pages/snapgene-viewer/index.js




























const ViewerPage = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("snapgene-viewer");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
            hero: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                    title: t("PAGE_TITLE"),
                    description: t("META_DESCRIPTION"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                            title: t("PAGE_TITLE"),
                            description: t("META_DESCRIPTION"),
                            locale: t("META_LOCALE"),
                            type: t("META_TYPE"),
                            url: t("META_URL"),
                            image: t("META_IMAGE"),
                            imageSecureUrl: t("META_IMAGE_SECURE"),
                            siteName: t("META_SITE_NAME"),
                            articlePublisher: t("META_ARTICLE_PUBLISHER"),
                            isImageBaseUrl: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                            title: t("PAGE_TITLE"),
                            description: t("META_DESCRIPTION"),
                            site: t("META_TWITTER_SITE"),
                            card: t("META_TWITTER_CARD"),
                            image: t("META_TWITTER_IMAGE"),
                            creator: t("META_TWITTER_CREATOR"),
                            isImageBaseUrl: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                            href: t("META_CANONICAL")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Author */.ZP.Author, {
                            content: t("META_AUTHOR")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                            children: t("HERO_TITLE")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description/* default */.Z, {
                            children: [
                                t("HERO_DESCRIPTION1"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                t("HERO_DESCRIPTION2")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                href: t("TRY_SNAPGENE_LINK"),
                                children: t("TRY_SNAPGENE_BTN")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleTemplate/* default */.Z, {
                    utility: {
                        bgColor: "white"
                    },
                    id: "hubspotViewerForm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate_Title/* default */.Z, {
                            children: t("DOWNLOAD_SNAPGENE_TITLE")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_ViewerForm, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                            sx: {
                                fontSize: "xs",
                                textAlign: "center"
                            },
                            children: t("DOWNLOAD_SNAPGENE_TEXT")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewerPageTemplate/* ViewerPageTemplateSection */.AQ, {
                    sm: 12,
                    md: 12,
                    lg: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateSectionTitle */.Wc, {
                            children: t("UNPARALLELED_VISIBILITY_TITLE")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateSectionSubTitle */.QA, {
                            children: t("UNPARALLELED_VISIBILITY_DESCRIPTION")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateSectionSubTitle */.QA, {
                            className: "mt-20",
                            children: t("TABLE_TITLE")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTablesSection */.Mv, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableWrapper */.cI, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveWrapper/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                                isBordered: true,
                                isStriped: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Thead/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Th/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Th/* default */.Z, {
                                                    align: "center",
                                                    isUppercaseNone: true,
                                                    spacing: {
                                                        p: 2
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionTitle */._b, {
                                                            children: t("TABLE_SECTION_TITLE1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewerPageTemplate/* ViewerPageTemplateTableSectionSubTitle */.F_, {
                                                            children: [
                                                                t("TABLE_SECTION_SUBTITLE1_1"),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " ",
                                                                t("TABLE_SECTION_SUBTITLE1_2")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
                                                            href: "#hubspotViewerForm",
                                                            size: "s",
                                                            children: t("DOWNLOAD_NOW_BTN")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Th/* default */.Z, {
                                                    align: "center",
                                                    isUppercaseNone: true,
                                                    spacing: {
                                                        p: 2
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionTitle */._b, {
                                                            children: t("TABLE_SECTION_TITLE2")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewerPageTemplate/* ViewerPageTemplateTableSectionSubTitle */.F_, {
                                                            children: [
                                                                t("TABLE_SECTION_SUBTITLE2_1"),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " ",
                                                                t("TABLE_SECTION_SUBTITLE2_2")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
                                                            href: t("TRY_FOR_FREE_LINK"),
                                                            size: "s",
                                                            isOutline2: true,
                                                            styleType: "secondary",
                                                            children: t("TRY_FOR_FREE_BTN")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tbody/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionText */.GI, {
                                                            children: t("TABLE_ROW1_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionText */.GI, {
                                                                children: t("TABLE_ROW2_TEXT")
                                                            }),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionText */.GI, {
                                                            children: t("TABLE_ROW3_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionText */.GI, {
                                                            children: t("TABLE_ROW4_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "times"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionText */.GI, {
                                                            children: t("TABLE_ROW5_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "times"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionText */.GI, {
                                                            children: t("TABLE_ROW6_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "times"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewerPageTemplate/* ViewerPageTemplateTableSectionText */.GI, {
                                                            children: t("TABLE_ROW7_TEXT")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "times"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                                                        sx: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: "check"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var snapgene_viewer = ((0,pipe/* default */.Z)(ViewerPage, (0,i18/* WithLocale */._t)({
    resources: (snapgene_viewer_page_default())
})));


/***/ }),

/***/ 98106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19334);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46003);






const SectionTryForFree = ()=>{
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("section-try-for-free");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "span",
                    children: t("TRY_FREE_TEXT")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Action */ .Z.Action, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Link */ .Z.Link, {
                    href: "/free-trial",
                    size: "s",
                    className: "ml-auto mr-auto",
                    children: t("TRY_FREE_BUTTON_TEXT")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTryForFree);


/***/ }),

/***/ 28813:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
class ActionFailException extends Error {
    /** @constructor
	 * @type {(message: string, code: null | string | number, stack: string[], originalError: Error)}
	 */ constructor(message, code = null, stack = [], originalError = {}){
        super("ActionFailException");
        this.name = this.constructor.name;
        this.code = code;
        this.message = message;
        /** @TODO: rename `stack` field to `details` */ this.stack = stack;
        this.originalError = originalError;
        this.localeMessage = this.stack[0] || this.message;
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (ActionFailException);


/***/ }),

/***/ 4116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37894);
/* harmony import */ var _insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86594);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28813);





const actionFallback = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((err)=>{
        if (!(err instanceof _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)) {
            // rethrowing err if it's not an ActionFailException
            throw err;
        }
        // suppressing ActionFailException
        setResultStatus({
            errors: err,
            hasErrors: true
        });
    });
const actionSuccess = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((result)=>{
        setResultStatus({
            result,
            errors: {},
            hasErrors: false
        });
        return result;
    });
const actionEnhancer = (setResultStatus)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(actionFallback(setResultStatus), actionSuccess(setResultStatus));
const getInitialState = ()=>({
        errors: {},
        hasErrors: false,
        result: undefined
    });
const useUniEffect = react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useResultStatus(action) {
    const unmounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const [resultStatus, setResultStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialState);
    const statusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    statusRef.current = resultStatus;
    useUniEffect(()=>()=>{
            unmounted.current = true;
        }, []);
    const updateResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((result)=>{
        if (unmounted.current) return;
        setResultStatus(result);
    }, []);
    const withResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>actionEnhancer(updateResultStatus)(// fallback decorator
        function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            setResultStatus(getInitialState);
            return action(...args);
        }), [
        action
    ]);
    const resetResult = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        if (statusRef.current.hasErrors) {
            // if there is no error, so there is no need to reset status
            setResultStatus(getInitialState);
        }
    }, []);
    return [
        withResultStatus,
        resultStatus,
        resetResult
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useResultStatus);


/***/ }),

/***/ 33686:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TRY_FREE_TEXT":"Discover the most <b>user-friendly</b> molecular biology experience.","TRY_FREE_BUTTON_TEXT":"Try for Free"}');

/***/ }),

/***/ 68241:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"SnapGene Viewer | Free software for plasmid mapping, primer design, and restriction site analysis","META_DESCRIPTION":"Make plasmid maps automatically, browse chromosomes, view and edit sequence traces, and share annotated DNA sequences with colleagues or customers.","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_IMAGE_SECURE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_TWITTER_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_URL":"https://www.snapgene.com/snapgene-viewer","META_CANONICAL":"https://www.snapgene.com/snapgene-viewer","PAGE_TITLE":"SnapGene Viewer | Free software for plasmid mapping, primer design, and restriction site analysis","HERO_TITLE":"SnapGene Viewer","HERO_DESCRIPTION1":"View, annotate and share sequence files with the free SnapGene Viewer.","HERO_DESCRIPTION2":"To edit, align and clone sequences, try the full version of SnapGene.","TRY_SNAPGENE_BTN":"Try SnapGene","TRY_SNAPGENE_LINK":"/free-trial","DOWNLOAD_SNAPGENE_TITLE":"Download SnapGene Viewer","DOWNLOAD_SNAPGENE_TEXT":"Your download will be available immediately.","UNPARALLELED_VISIBILITY_TITLE":"Gain Unparalleled Visibility of Your Plasmids","UNPARALLELED_VISIBILITY_DESCRIPTION":"With SnapGene Viewer you can view plasmid maps, annotate features, and share sequences with your colleagues for free. And when you want to do more, subscribe to SnapGene to simulate cloning and PCR, validate sequenced constructs and customize your plasmids.","TABLE_TITLE":"What are the differences between SnapGene and SnapGene Viewer?","TABLE_SECTION_TITLE1":"SnapGene Viewer","TABLE_SECTION_TITLE2":"SnapGene","TABLE_SECTION_SUBTITLE1_1":"Free software that allows you to create, browse,","TABLE_SECTION_SUBTITLE1_2":"and share richly annotated sequence files.","TABLE_SECTION_SUBTITLE2_1":"The easiest way to plan, visualize and document","TABLE_SECTION_SUBTITLE2_2":"your everyday molecular cloning procedures.","DOWNLOAD_NOW_BTN":"Download now","TRY_FOR_FREE_BTN":"Try for Free","DOWNLOAD_NOW_LINK":"Download now","TRY_FOR_FREE_LINK":"/free-trial","TABLE_ROW1_TEXT":"View plasmid maps and sequence trace files","TABLE_ROW2_TEXT":"Annotate features on your plasmids","TABLE_ROW3_TEXT":"Share your sequences with colleagues","TABLE_ROW4_TEXT":"Sequence editing and alignment","TABLE_ROW5_TEXT":"Simulate cloning, PCR and mutagenesis","TABLE_ROW6_TEXT":"Customize annotations and enzyme sets","TABLE_ROW7_TEXT":"Automatically create graphical history","errors":{"INVALID_EMAIL":"Please enter valid email.","EMAIL_REQUIRED":"Please enter your email.","WRONG_EMAIL":"Please enter valid email.","EMAIL_INVALID_LENGTH":"Please enter valid email (up to 64 characters)."},"SUBMIT":"Download"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,8930,8914,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(29404); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);